import uuid from "uuid/v4";
import { createModule } from "direct-vuex";
import { BatchState, RawBatch, RawRequestBody, BatchResource } from "./types";
import { moduleActionContext } from "..";
import { ParseError } from "papaparse";
import actions from "./actions";

const batch = createModule({
  namespaced: true,
  state: (): BatchState => {
    return {
      batches: {},
      batchesList: [],
      selected: {
        id: uuid(),
        name: "",
        description: "",
        state: "",
        raw_requests: []
      }
    };
  },
  getters: {
    batches(state) {
      return (state.batchesList || []).map(id => {
        return state.batches[id];
      });
    }
  },
  mutations: {
    UPDATE_SELECTED(state, attrs: Partial<RawBatch>) {
      state.selected = { ...state.selected, ...attrs };
    },
    ADD_REQUEST_TO_SELECTED(
      state,
      args: { request: RawRequestBody; errors: ParseError[] }
    ) {
      state.selected.raw_requests.push({
        id: uuid(),
        body: args.request,
        errors: args.errors,
        edited: false
      });
    },
    REMOVE_REQUEST_FROM_SELECTED(state, index) {
      state.selected.raw_requests.splice(index, 1);
    },
    CLEAR_REQUESTS_FROM_SELECTED(state) {
      state.selected.raw_requests = [];
    },
    SET_BATCHES(state, batches: BatchResource[]) {
      state.batches = {};
      state.batchesList = [];

      batches.forEach(batch => {
        state.batches[batch.id] = batch;
        state.batchesList.push(batch.id);
      });
    },
    UPDATE_BATCH(state, batch: BatchResource) {
      let idx = state.batchesList.findIndex(b => {
        return b == batch.id;
      });
      state.batches[batch.id] = batch;
      state.batchesList.splice(idx, 1, batch.id);
    },
    REMOVE_BATCH(state, id: string) {
      let idx = state.batchesList.findIndex(b => {
        return b == id;
      });
      state.batchesList.splice(idx, 1);
      delete state.batches[id];
    },
    CLEAR_SELECTED(state) {
      state.selected = {
        id: uuid(),
        name: "",
        description: "",
        state: "",
        raw_requests: []
      };
    }
  },
  actions: actions
});

export default batch;
export const batchActionContext = (context: any) =>
  moduleActionContext(context, batch);
